// Copyright © Veeam Software Group GmbH

export enum RestoreWizardPanelsEnum {
    RestoreOptions = 'RestoreOptions',
}
